<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { CtaBlock } from '../../types'

defineProps<{ block: CtaBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:px-4 site:py-12 site:@min-[40rem]:px-6 site:@min-[40rem]:py-20">
    <div class="site:mx-auto site:max-w-6xl site:bg-(--site-color-primary) site:px-6 site:py-14 site:text-center site:text-(--site-color-primary-text) site:shadow-(--site-shadow-md) site:@min-[40rem]:px-12 site:@min-[40rem]:py-20" :style="{ borderRadius: 'var(--site-radius-lg)' }">
      <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:opacity-90" />
      <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mx-auto site:mt-3 site:max-w-3xl site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
      <SiteEditableText v-model="block.content.description" as="p" class="site:mx-auto site:mt-5 site:max-w-2xl site:text-lg site:leading-8 site:opacity-90" />
      <div class="site:mt-8 site:flex site:flex-wrap site:justify-center site:gap-3">
        <SiteLink :link="block.content.primaryAction" class="site:inline-flex site:items-center site:justify-center site:rounded-(--site-radius-sm) site:bg-(--site-color-surface) site:px-5 site:py-3 site:text-sm site:font-bold site:text-(--site-color-text)">
          {{ block.content.primaryAction.label }}
        </SiteLink>
        <SiteLink v-if="block.content.secondaryAction" :link="block.content.secondaryAction" class="site:inline-flex site:items-center site:justify-center site:rounded-(--site-radius-sm) site:border site:border-current site:px-5 site:py-3 site:text-sm site:font-bold">
          {{ block.content.secondaryAction.label }}
        </SiteLink>
      </div>
    </div>
  </section>
</template>
